// @flow
import React, {Component} from 'react';
import './Navbar.css';

export default class Navbar extends Component {

  props: {
    onAboutButtonClick: EventHandler
  };

  render() {
    return (
      <header className="site-header" role="banner">
        <div className="container">
          <a className="home-link" href="/">Real-Time Debate Scorecard <sup>BETA</sup></a>
          <nav className="site-nav" role="navigation">
            <ul className="nav-items">
              <li className="nav-item">
                <a onClick={this.props.onAboutButtonClick}>About</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Navbar.js
 **/